// eslint-disable-next-line no-unused-vars
export const FUNCTION = Object.freeze((...props: any[]) => {});
export const ARRAY = [];

export const REQUIRED_ARRAY = (array: any = ARRAY): any[] => (Array.isArray(array) ? array : ARRAY);
